$(document).ready(function() {
  const $body = $('body');
    
  // prepend general message to header
  $('.generalmessage').prependTo('.header');

  // custom header search field functionality
  const nav = $('#mainNavigation');
  const directions = $('.standAloneDirections');

  function handleSearch() {
    const input = $('.customSearch__input');
    const value = input.val();
    if (value !== '') { 
      $('.searchBox .inputFieldTextbox').val(value);
      $('.searchBox .searchSubmitButton').click();
    } else {
      return false;
    }
  }

  $('.customSearch').on('click keypress', function(e) {
    e.preventDefault();
    if (e.key === 'Enter' || e.type === 'click') {
      const wrapper = $('.customSearch-wrapper');
      if (!wrapper.hasClass('search-active')) {
        nav.fadeOut('fast');
        directions.fadeOut('fast');
        wrapper.fadeOut('fast', function() {
          wrapper.addClass('search-active');
          wrapper.fadeIn('fast', function() {
            $('.customSearch__input').focus();
          });
        })
      } else {
        handleSearch();
      }
    }
  });

  $('.customSearch__input').on('keypress', function(e) {
    if (e.key === 'Enter') {
      handleSearch();
    }
  });

  $('.customSearch__close').on('click keypress', function(e) {
    const wrapper = $('.customSearch-wrapper');
    wrapper.fadeOut('fast', function() {
      wrapper.removeClass('search-active');
      wrapper.fadeIn('fast');
      nav.fadeIn('fast');
      directions.fadeIn('fast');
    });
  });


  // custom email signup functionality
  if ($body.hasClass('homepage')) {
    function handleCustomEmailSignup() {
      let submitBtn = $('.custom-email-signup__submit');
      
      submitBtn.on('keypress click', function(e) {
        if (e.key === 'Enter' || e.type === 'click') {
          let val = $('.custom-email-signup__input').val();
          $('.afterContent .emailSignup .inputFieldTextbox').val(val);
          $('.afterContent .emailSignup .emailSubmitButton').click();
        }
      });
    }
    handleCustomEmailSignup();
  }


  // homepage tier 2 parallax
  if ($body.hasClass('homepage')) {
    $('.section-tier-two').prepend('<div id="plx-img"></div>');
    const tiertwo = $('.section-tier-two');
    const tierTwoCards = $('#cardWidgetSpecialFeature');
    const plxImg = $('#plx-img');

    function isInViewport(node) {
      let rect = node.getBoundingClientRect()
      return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    function throttle(fn, wait) {
      let time = Date.now();
      return function() {
        if ((time + wait - Date.now()) < 0) {
          fn();
          time = Date.now();
        }
      }
    }

    function plx() {
      let scrolled = $(window).scrollTop()
      let initY = tiertwo.offset().top
      let height = tiertwo.height()
      let t2ch = tierTwoCards.height();
      let visible = isInViewport(tiertwo[0])

      if(visible) {
        let diff = scrolled - initY
        let ratio = Math.round((diff / height) * 100)
        plxImg.css('transform',`translateY(${30 + t2ch + parseInt(-(ratio * 5))}px)`);
      }
    }

    window.addEventListener('scroll', throttle(plx, 100));

  }


  // remove separators from footer navigation 
  $('.footer .separator').remove();

  // change footer saffire logo img
  $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);


  // nav dropdown animation css
  $('#mainNavigation .group').each(function() {
    const items = $(this).children('.items');
    const item = items.children('.item');
    let time = 0;
    item.each(function(i) {
      $(this).css("animation", `slideDown 300ms ${time}ms ease-in-out forwards`);
      time += 60;
    })
  });

  // subpage theme hero container
  if ($body.hasClass('subpage-theme')) {
    const firstSection = $('.entityContainerRow.rowIndex-1');
    const title = firstSection.find('.dynamicPageTitle').text();
    const image = firstSection.find('.ImageModule img').attr('data-src');
    const heroHTML = `
      <div class="hero-container" style="background-image: url('${image}')">
        <div>
          <h1>${title}</h1>
        </div>
      </div>
    `;
    firstSection.remove();
    $(heroHTML).insertAfter('.header');
  }

});


$(window).load(function() {
  function removeFooterNavBtnClass() {
    if ($('body').hasClass('saffireMobileSize')) {
      $('.footerItems1 a').removeClass('button');
    };
  }
  removeFooterNavBtnClass();

  $(window).resize(function() {
    removeFooterNavBtnClass();
  });
});
